
















import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
import * as api from '@/api';
import { Dialog } from 'vant';
@Component({})
export default class extends Vue {
  @Prop() showDeptPicker: boolean;
  @Watch('showDeptPicker', { deep: true, immediate: true })
  async ShowDeptPicker(val: boolean) {
    this.show = val;
  }
  show: boolean = false;
  columns: any = [];
  deptData: any = [];

  searchValue: string = '';
  onSearch() {
    this.columns = this.columns.filter((item: any) => item.deptName.includes(this.searchValue));
    if (!this.searchValue) this.columns = this.deptData;
  }
  clear() {
    this.columns = this.deptData;
  }

  mounted() {
    this.getAllDepts();
  }
  async getAllDepts() {
    try {
      const { data } = await api.AccountApp.getAllDepts_GET();
      this.deptData = data;
      this.columns = JSON.parse(JSON.stringify(this.deptData));
      this.$emit('deptBind', this.columns);
    } catch (err) {
      Dialog.alert({
        message: err,
        title: '提示',
      });
    }
  }
  onConfirm(val: string) {
    this.$emit('deptConfirm', val);
  }
  onCancel() {
    this.$emit('deptCancel');
  }
}
